/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const MCsmallcard = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 36 24">
            <defs>
                <polygon
                    id="path-1"
                    points="3.72321802e-16 17.7557838 3.72321802e-16 0.241841708 14.1679703 0.241841708 14.1679703 17.7557838"
                />
                <polygon
                    id="path-3"
                    points="7.14437027 17.7567568 14.2287568 17.7567568 14.2287568 0.240810811 0.0599837838 0.240810811 0.0599837838 17.7567568"
                />
            </defs>
            <g
                id="Temporary-pages"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="smallcard_mastercard">
                    <g id="Page-1" transform="translate(3.000000, 3.000000)">
                        <polygon
                            id="Fill-1"
                            fill="#FF5F00"
                            points="10.3368649 15.8864108 17.999027 15.8864108 17.999027 2.11641081 10.3368649 2.11641081"
                        />
                        <g
                            id="Group-8"
                            transform="translate(0.000000, 0.002384)"
                        >
                            <g id="Group-4">
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-1" />
                                </mask>
                                <g id="Clip-3" />
                                <path
                                    d="M10.8233757,9.00024324 C10.8204568,6.31264865 12.0539432,3.77318919 14.1679703,2.11402703 C10.3655919,-0.874459459 4.86051081,-0.214297297 1.87202432,3.58808108 C-1.11621892,7.39045946 -0.4563,12.8957838 3.34632162,15.884027 C6.52186216,18.3797027 10.9924297,18.3797027 14.1679703,15.884027 C12.054673,14.2251081 10.8211865,11.6868649 10.8233757,9.00024324"
                                    id="Fill-2"
                                    fill="#EB001B"
                                    mask="url(#mask-2)"
                                />
                            </g>
                            <g
                                id="Group-7"
                                transform="translate(14.108108, 0.000000)"
                            >
                                <mask id="mask-4" fill="white">
                                    <use xlinkHref="#path-3" />
                                </mask>
                                <g id="Clip-6" />
                                <path
                                    d="M14.2289027,9.00024324 C14.2286595,13.8364054 10.3080649,17.7567568 5.4719027,17.7567568 C3.50892973,17.7567568 1.60311892,17.0970811 0.0599837838,15.884027 C3.86236216,12.8957838 4.52252432,7.39045946 1.53403784,3.58808108 C1.10301081,3.03981081 0.608254054,2.54481081 0.0599837838,2.11402703 C3.86187568,-0.875189189 9.36695676,-0.216243243 12.356173,3.58589189 C13.569227,5.12878378 14.2286595,7.03483784 14.2289027,8.99781081 L14.2289027,9.00024324 Z"
                                    id="Fill-5"
                                    fill="#F79E1B"
                                    mask="url(#mask-4)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

MCsmallcard.defaultProps = { className: '' };

MCsmallcard.propTypes = { className: PropTypes.string };

export default MCsmallcard;
